var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import InputMask from 'react-input-mask';
import { TextField } from '@mui/material';
import { useComparisonFilter } from './useComparisonFilter';
var TimeFilter = function (_a) {
    var timeColumn = _a.timeColumn, onFilterChange = _a.onFilterChange;
    var _b = useComparisonFilter(timeColumn, onFilterChange), comparisonSelectorComponent = _b[0], onFilterValueChange = _b[2];
    return (React.createElement("div", { className: "columnFilter timeFilter" },
        comparisonSelectorComponent,
        React.createElement("div", { className: "timeFilter__timePicker" },
            React.createElement(InputMask, { onChange: onFilterValueChange, disabled: !timeColumn.filterable, mask: "99:59:59", maskChar: "_", formatChars: {
                    '9': '[0-9]',
                    '5': '[0-5]'
                }, name: "duration", fullWidth: true }, function (textFieldProps) { return React.createElement(TextField, __assign({}, textFieldProps)); }))));
};
export default TimeFilter;
//# sourceMappingURL=TimeFilter.js.map